/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02Ljk2IDIuNUg1LjE5VjQuMjdINi45NlYyLjVaTTEwLjgxIDIuNUg5LjA0VjQuMjdIMTAuODFWMi41Wk01LjE5IDcuMTJINi45NlY4Ljg5SDUuMTlWNy4xMlpNMTAuODEgNy4xMkg5LjA0VjguODlIMTAuODFWNy4xMlpNNS4xOSAxMS43M0g2Ljk2VjEzLjVINS4xOVYxMS43M1pNMTAuODEgMTEuNzNIOS4wNFYxMy41SDEwLjgxVjExLjczWiIgZmlsbD0iaW5oZXJpdCIvPg==";